import AdminTimeKeeping from './admin';
import ClientTimeKeeping from './client';
import ContractorTimeKeeping from './contractor';

const tenants = {
    admin: AdminTimeKeeping,
    client: ClientTimeKeeping,
    contractor: ContractorTimeKeeping
};

export default tenants;



// WEBPACK FOOTER //
// ./src/pages/timekeeping/tenants/index.jsx